import PersonalData from './PersonalData';

export default PersonalData;
